import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '主题合集', href: '#index' },
  { label: '最新动态', href: '#updates' },
  { label: '联系我们', href: '#contact' },
  { label: '精彩推荐', href: '#media' },
  { label: '读者评价', href: '#comments' },
  { label: '平台优势', href: '#features' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[68px]">
          <a
            href="#hero"
            className="flex items-center gap-2 whitespace-nowrap cursor-pointer"
          >
            <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl text-foreground-900">
              5151漫画网
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="px-3 py-2 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/60 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg bg-background-100 cursor-pointer"
            aria-label="Toggle menu"
          >
            <i
              className={`${
                mobileOpen ? 'ri-close-line' : 'ri-menu-line'
              } text-foreground-700 text-lg`}
            ></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60">
          <nav className="flex flex-col px-4 py-3 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMobileOpen(false)}
                className="px-3 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/60 rounded-md transition-colors whitespace-nowrap cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}